import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from '../services/session.service';

@Injectable()
export class AdminGuard {
  constructor(private readonly sessionService: SessionService) {}

  public canActivate: CanActivateFn = (
    _next: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean => {
    const token = this.sessionService.getToken();
    const isAdmin = this.sessionService.isAdmin();
    return !!token && isAdmin;
  };
}
